import { FC } from "react";
import { ids } from "~/constants";
import { Anchor } from "../Anchor";
import { Chunk } from "./Chunk";
import { NewsletterForm } from "./NewsletterForm";

export const NewsletterChunk: FC = () => {
  return (
    <Chunk smHeading="Join our newsletter" lgHeading="The Egg Drop">
      <Anchor id={ids.newsletter}>
        <NewsletterForm />
      </Anchor>
    </Chunk>
  );
};
